<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="rr-list">
                    <icon name="clipboard-list"></icon>
                    รายการรับสินค้า
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "rr-layout"
    }
</script>

<style scoped>

</style>